import { ReactNode } from "react";

import { classNames } from "@helpers/css";

const ProfileContainer = ({
  children,
  title,
  topRightContent,
  bare = false,
  className,
}: {
  children: ReactNode;
  title?: string;
  topRightContent?: ReactNode;
  bare?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "flex flex-col text-sm",
        bare ? "gap-6" : "gap-6 border rounded-lg p-6",
        className,
      )}
    >
      {(topRightContent || title) && (
        <div
          className={classNames(
            "flex items-center justify-between",
            bare && "pt-2",
          )}
        >
          {title && (
            <div
              className={classNames(
                "flex-1 text-left",
                bare
                  ? "text-lg font-semibold text-gray-900"
                  : "tf-header-base-dark",
              )}
            >
              {title}
            </div>
          )}
          {topRightContent}
        </div>
      )}
      {children}
    </div>
  );
};

export default ProfileContainer;
